import { render, staticRenderFns } from "./FleetItemList.vue?vue&type=template&id=530905bc&scoped=true&"
import script from "./FleetItemList.vue?vue&type=script&lang=js&"
export * from "./FleetItemList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530905bc",
  null
  
)

export default component.exports